import React, { Component } from 'react'
import classes from './Login.module.css'
import Image1 from '../../Assests/Image/Register.png'
import Image2 from '../../Assests/Image/illlustration2.png'
import Image3 from '../../Assests/Image/illlustration4.png'
import * as action from '../../Store/Action/index'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import SimpleReactValidator from 'simple-react-validator';
import CircularProgress from '@material-ui/core/CircularProgress';
import Slider from 'infinite-react-carousel';
import {Alert} from 'antd'
class Login extends Component {
    constructor() {
        super()
        this.validator = new SimpleReactValidator({
            element: (message, className) => <div className={classes.validation}>{message}</div>
        });
    }
    toHome = () => {
        this.props.history.push("/")
    }
    state = {
        loginData: {
            email: "",
            password: ""
        },
        formInvalid: true
    }
    ClickHandler = () => {
        if (this.validator.allValid()) {

            this.props.onAuth(this.state.loginData.email, this.state.loginData.password)

        }
        else {
            this.validator.showMessages();
        }

    }

    onChangeHandler = (identifier, e) => {
        this.props.onClear();
        let formInvalid = this.state.formInvalid
        let updatedData = {
            ...this.state.loginData
        }
        let updatedElement = {
            ...updatedData[identifier]
        }
        updatedElement = e.target.value
        updatedData[identifier] = updatedElement
        if (this.validator.allValid()) {
            formInvalid = false
        } else {
            formInvalid = true
            this.validator.showMessages();
        }

        this.setState({ loginData: updatedData, formInvalid: formInvalid })


    }
    render() {
        console.log(this.props.allValid)
        let redirect = null
        if (this.props.isRedirect) {
            redirect = (<Redirect to="/billing-page" />)
        }
        console.log(this.props.allValid)
        let errorMessage = null
        if (!this.props.allValid) {
            errorMessage =  <Alert message={this.props.error} type="error" />
        }
        let form = (<div className={classes.registerForm}>
            <input className={classes.input} placeholder="Email ID" onChange={(event) => this.onChangeHandler("email", event)}></input>
            {}
            {this.validator.message('email', this.state.loginData.email, 'required|email')}
            <input className={classes.input} type='password' placeholder="Password" onChange={(event) => this.onChangeHandler("password", event)}></input>
            {}
            {this.validator.message('password', this.state.loginData.password, 'required')}
            <center><button onClick={this.ClickHandler} className={classes.btn}>Login</button></center>


        </div>)
        if (this.props.loading) {
            form = <div className={classes.loading}> <CircularProgress /></div>
        }
        return (
            <div className={classes.cont}>
                <div className={classes.registerCont}>
                    {redirect}
                  
                    <div className={classes.form}>
                    <div className = {classes.toHome} onClick = {this.toHome}>
                <img src="https://test-server.glossaread.com/webroot/css/front_end/new_design/images/glossaread_logo_wht.svg"/>
            </div>
                        <p className={classes.formHeading}>
                            Login 
                </p>
                        {errorMessage}
                        {form}
                    </div>
                    <div className={classes.illusCont}>
                        <center>
                            <Slider arrows={false} dots autoplay>
                                <div className={classes.illus}>

                                    <img  className = {classes.img} src={Image1} alt="ilustration"></img>
                                </div>
                                <div className={classes.illus2}>
                                    <img  className = {classes.img2} src={Image2} alt="ilustration"></img>
                                </div>
                                <div  className={classes.illus}>
                                    <img src={Image3} alt="ilustration" className = {classes.img}></img>
                                </div>

                            </Slider>
                            <p className={classes.heading}>New Here?</p>
                            <p className={classes.content}>

                                Signup and discover great amount of new opportunities
                </p>
                            <button onClick={() => this.props.history.push('/register')} className={classes.btn2}>Signup</button>
                        </center>
                    </div>
                </div>
            </div>

        )
    }


}
const mapStateToProps = (state) => {
    return {
        allValid: state.auth.allValid,
        loading: state.auth.loading,
        error: state.auth.error,
        isAuth: state.auth.token !== null,
        isRedirect: state.auth.isRedirect
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        onAuth: (email, password) => dispatch(action.auth(email, password)),
        onClear: () => dispatch(action.clearError())

    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Login)